import React, { ReactNode } from "react";
import { Flex, Text } from "@chakra-ui/react";

interface Props {
  // "1 / 4" — 탭 안의 단계가 하나뿐인 화면은 넘기지 않는다.
  stepLabel?: string;
  stepAriaLabel?: string;
  // 배지만으로 무엇을 할 자리인지 드러나는 화면은 제목을 비운다.
  title?: ReactNode;
  // 제목 오른쪽 배지 — 주문 안내의 `실제 주문 화면 체험` 처럼 화면 성격을 알리는 chip.
  titleBadge?: ReactNode;
  description?: ReactNode;
  // 우측 하단 이동 버튼과 비활성 힌트.
  actions: ReactNode;
  // 설명 아래에 더 붙는 내용(선택 수 표시 등).
  children?: ReactNode;
}

/**
 * 카드 헤더 아래에 오는 단계 패널.
 *
 * 카드 제목·설명은 그 탭 전체를 설명하고, 이 패널은 지금 할 일 하나를 설명한다.
 * 둘을 테두리로 갈라 두면 여러 화면을 오갈 때 어디가 바뀌는 부분인지 바로 보인다.
 * 이동 버튼도 이 안에 들어간다 — 가이드의 모든 탭이 같은 자리에서 앞뒤로 움직인다.
 */
function PathPickStartGuideStepPanel({
  stepLabel,
  stepAriaLabel,
  title,
  titleBadge,
  description,
  actions,
  children,
}: Props) {
  return (
    <Flex
      flexDirection={"column"}
      gap={"12px"}
      padding={"16px"}
      borderRadius={"8px"}
      border={"0.5px solid #E5E5E3"}
      backgroundColor={"#FCFCFB"}
    >
      <Flex alignItems={"flex-end"} gap={"12px"} flexWrap={"wrap"}>
        <Flex flexDirection={"column"} gap={"4px"} minWidth={0} flexGrow={1}>
          {stepLabel && (
            <Text
              textStyle={"caption-bold"}
              color={"#1272EF"}
              role={"status"}
              aria-label={stepAriaLabel}
            >
              {stepLabel}
            </Text>
          )}
          <Flex gap={"8px"} alignItems={"center"} flexWrap={"wrap"}>
            {title && (
              <Text textStyle={"body-md-bold"} color={"#22221F"}>
                {title}
              </Text>
            )}
            {titleBadge}
          </Flex>
          {description && (
            <Text textStyle={"body-sm-medium"} color={"#6F6F6C"}>
              {description}
            </Text>
          )}
        </Flex>
        {/* 설명이 길어 행이 줄바꿈되면 justifyContent 로는 오른쪽에 붙지 않는다
            (항목이 하나뿐인 줄은 줄 시작에 놓인다). marginLeft 로 밀어야 한다. */}
        <Flex flexShrink={0} marginLeft={"auto"}>
          {actions}
        </Flex>
      </Flex>
      {children}
    </Flex>
  );
}

export default PathPickStartGuideStepPanel;
